import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkOutsideOfJapan'
})
export class CheckOutsideOfJapanPipe implements PipeTransform {
  transform(value: string, mailType: string): string {
    if (mailType === 'project') {
      if (value === 'JAP' || value === 'JPN') {
        return 'NG';
      } else if (value === 'ANY') {
        return 'OK';
      } else {
        return null;
      }
    } else if (mailType === 'worker') {
      if (!value || value === 'JAP' || value === 'JPN' || value === 'ANY') {
        return null;
      } else {
        return '外国';
      }
    }
  }
}
